import dayjs from 'dayjs';

function isExpired(session) {
  return session.expires_at != null && dayjs().diff(session.expires_at) >= 0;
}

export { isExpired };
